import { createFeature, createReducer, on } from '@ngrx/store';
import { SettingsEmail } from '../../../../shared/services/settings/settings.service';
import { settingsEmailActions } from './settings-email.actions';

export const SETTINGS_EMAIL_FEATURE_KEY = 'settingsEmail';

export type SettingsEmailStatus = 'idle' | 'loading' | 'loaded' | 'error';
export type SettingsEmailMutationStatus = 'idle' | 'pending';

export interface SettingsEmailState {
  settings: SettingsEmail | null;
  status: SettingsEmailStatus;
  mutationStatus: SettingsEmailMutationStatus;
  error: string | null;
}

export const initialSettingsEmailState: SettingsEmailState = {
  settings: null,
  status: 'idle',
  mutationStatus: 'idle',
  error: null,
};

export const settingsEmailReducer = createReducer(
  initialSettingsEmailState,
  on(settingsEmailActions.loadSettingsEmail, state => ({
    ...state,
    status: 'loading',
    error: null,
  })),
  on(settingsEmailActions.loadSettingsEmailSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsEmailActions.loadSettingsEmailFailure, (state, { error }) => ({
    ...state,
    status: 'error',
    mutationStatus: 'idle',
    error,
  })),
  on(settingsEmailActions.updateSettingsEmail, state => ({
    ...state,
    mutationStatus: 'pending',
    error: null,
  })),
  on(settingsEmailActions.connectGoogle, settingsEmailActions.exchangeGoogleCode, state => ({
    ...state,
    mutationStatus: 'pending',
    error: null,
  })),
  on(settingsEmailActions.updateSettingsEmailSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsEmailActions.exchangeGoogleCodeSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsEmailActions.updateSettingsEmailFailure, (state, { error }) => ({
    ...state,
    mutationStatus: 'idle',
    error,
  })),
  on(settingsEmailActions.connectGoogleFailure, settingsEmailActions.exchangeGoogleCodeFailure, (state, { error }) => ({
    ...state,
    mutationStatus: 'idle',
    error,
  })),
);

export const settingsEmailFeature = createFeature({
  name: SETTINGS_EMAIL_FEATURE_KEY,
  reducer: settingsEmailReducer,
});
